import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'projects/ProjetoBaseAngular/app/shared.module';

import { GaleriaModule } from 'projects/ProjetoBaseAngular/app/admin/galeria/galeria.module';
import { RevistaComponent } from './revista.component';
import { RevistaModalComponent } from './revista-modal/revista-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    GaleriaModule
  ],
  declarations: [
    RevistaComponent,
    RevistaModalComponent
  ]
})
export class RevistaModule { }
